var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"id":"content-title"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h3',{staticClass:"mb-0"},[_vm._v("Stock Out")])])])],1),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }